import { Phone, ArrowUpRight } from "lucide-react";
import { BRAND, SPECIALTIES } from "@/data/content";
import { MaskLine, FadeUp } from "@/components/Reveal";

export default function Specialties() {
  return (
    <section id="specialties" data-testid="specialties-section" className="relative py-20 md:py-32 overflow-hidden">
      <div className="absolute top-1/3 left-[-15%] w-[36rem] h-[36rem] rounded-full bg-gold/[0.07] blur-[130px] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="max-w-2xl">
          <FadeUp>
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold">Chef’s Recommended Specialties</p>
          </FadeUp>
          <h2 className="mt-4 font-display font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight text-cream">
            <MaskLine>Bappu’s picks from</MaskLine>
            <MaskLine delay={0.1}>
              <em className="italic font-light text-gold">today’s counter</em>
            </MaskLine>
          </h2>
        </div>

        <div className="mt-14 md:mt-20 grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SPECIALTIES.map((s, i) => (
            <FadeUp key={s.numeral} delay={i * 0.12} className="h-full">
              <article
                data-testid={`specialty-card-${i + 1}`}
                className="group h-full flex flex-col rounded-3xl overflow-hidden bg-cocoa-900 border border-gold/15 hover:border-gold/45 hover:-translate-y-2 transition-all duration-300 shadow-[0_20px_40px_-25px_rgba(0,0,0,0.8)]"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.alt}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"
                  />
                  <span className="absolute top-4 left-4 rounded-full bg-cocoa-950/80 backdrop-blur-sm border border-gold/30 px-3.5 py-1.5 text-[10px] uppercase tracking-[0.2em] text-gold">
                    {s.tag}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-6 md:p-7">
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-3xl font-light text-gold/40 leading-none">{s.numeral}</span>
                    <h3 className="font-display font-semibold text-xl sm:text-2xl text-cream leading-snug">
                      {s.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-cream/60 text-sm leading-relaxed flex-1">{s.desc}</p>
                  <a
                    data-testid={`specialty-call-${i + 1}`}
                    href={`tel:${BRAND.phones[0]}`}
                    className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-gold-light transition-colors duration-200"
                  >
                    <Phone className="w-4 h-4" />
                    Call to order
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
